<template>
  <div>
    <loader v-if="plan === null"></loader>
    <fetch-error
      v-else-if="plan instanceof FetchError"
      @retry="fetchData()"
      :error="plan"
    ></fetch-error>
    <template v-else>
      <vs-row>
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          پلن فعال:
          <h5>{{ plan.title }}</h5>
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          تاریخ انقضا:
          <h5>{{ plan.expires_at_human_readable }}</h5>
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          تعداد پیامک ارسال شده:
          <h5>{{ sms.count }} عدد</h5>
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          هزینه پیامک ارسال شده:
          <h5>{{ sms.cost.toString().numberFormat() }} ریال</h5>
        </vs-col>
      </vs-row>
    </template>
  </div>
</template>

<script>
import FetchError from "../../services/api/FetchError";
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  data() {
    return {
      plan: {
        title: "",
        expires_at: "",
      },
      sms: {
        count: "",
        cost: "",
      },
      FetchError,
    };
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
  methods: {
    getProviderPlans() {
      providerApiService
        .getProviderPlans(this.currentProvider.id)
        .then((result) => (this.plan = result))
        .catch((e) => console.log(e));
    },
    getProviderSms() {
      providerApiService
        .getProviderSms(this.currentProvider.id)
        .then((result) => (this.sms = result))
        .catch((e) => console.log(e));
    },
  },
  mounted() {
    this.getProviderPlans();
    this.getProviderSms();
  },
};
</script>

<style lang="scss">
.radio {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.radio-btn {
  margin: 0 10px;
}
.radio-title {
  margin: 0 10px;
}
</style>
